import React from "react";

const SITE_LINKS = [
  { href: "/", label: "Home" },
  { href: "/about", label: "About" },
  { href: "/pricing", label: "Pricing" },
  { href: "/community", label: "Community" },
];

const STUDIO_LINKS = [
  { href: "https://redmonkstudios.com/about", label: "Our Studio" },
  { href: "https://redmonkstudios.com/contact-us", label: "Contact" },
  { href: "https://redmonkstudios.com/privacy-policy", label: "Privacy Policy" },
  { href: "https://redmonkstudios.com/terms-of-service", label: "Terms of Service" },
];

/**
 * Shared footer for every marketing page (Landing, About, Pricing,
 * Community) -- previously copy-pasted per page, now a single source.
 */
export default function MarketingFooter({ logo, redmonklogo }) {
  return (
    <footer className="mk-footer">
      <div className="container">
        <div className="mk-footer-top">
          <div className="mk-footer-brand">
            <img src={logo} alt="Mailinflow Logo" height={26} />
            <p className="mk-footer-tagline">
              Pocket-friendly email marketing and lead-gen forms for
              startups and small teams.
            </p>
          </div>

          <div className="mk-footer-links">
            <div className="mk-footer-col">
              <span className="mk-footer-col-title mk-mono">Site</span>
              {SITE_LINKS.map((link) => (
                <a href={link.href} key={link.href}>
                  {link.label}
                </a>
              ))}
            </div>
            <div className="mk-footer-col">
              <span className="mk-footer-col-title mk-mono">Studio</span>
              {STUDIO_LINKS.map((link) => (
                <a
                  href={link.href}
                  key={link.href}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="mk-footer-bottom">
          <span className="mk-footer-copyright">
            &copy; Copyrights {new Date().getFullYear()} Redmonk Studios
            (OPC) Private Limited. All rights reserved.
          </span>
          <span className="mk-footer-powered mk-mono">
            Powered by
            <img src={redmonklogo} alt="Redmonk Logo" height={14} />
          </span>
        </div>
      </div>
    </footer>
  );
}
